import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

import * as styles from './RemoveFromSubscriptionModal.css';

type RemoveFromSubscriptionModalProps = {
  isOpen: boolean;
  programName: string;
  isConfirming?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const RemoveFromSubscriptionModal = ({
  isOpen,
  programName,
  isConfirming = false,
  onConfirm,
  onClose,
}: RemoveFromSubscriptionModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Remove from subscription"
      modalClassName={styles.modalWidth}
      centerContent={true}
    >
      <div
        className={styles.content}
        data-testid="remove-from-subscription-modal"
      >
        {programName ? (
          <Typography variant="body" size="large" fontWeight="bold">
            {programName}
          </Typography>
        ) : null}
        <Typography variant="body" size="large" fontWeight="normal">
          Subscribers lose access immediately.
        </Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          This program will be removed from your subscription and can be added
          to other offers.
        </Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          You can reverse this anytime by selecting &ldquo;Sell with
          Subscription&rdquo; again.
        </Typography>
        <div className={styles.actions}>
          <Button variant="text" color="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button color="error" onClick={onConfirm} disabled={isConfirming}>
            Yes, remove from subscription
          </Button>
        </div>
      </div>
    </Modal>
  );
};
